import { createSlice } from "@reduxjs/toolkit";

import { PaymentSchema } from "../types/paymentSchema";
import { fetchPaymentMethods } from "../services/fetchPaymentMethods";

const initialState: PaymentSchema = {};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentMethods.pending, (state) => {
        state.paymentMethodsIsLoading = true;
        state.paymentMethodsError = undefined;
      })
      .addCase(fetchPaymentMethods.fulfilled, (state, action) => {
        state.paymentMethodsIsLoading = false;
        state.paymentMethodsData = action.payload;
      })
      .addCase(fetchPaymentMethods.rejected, (state, action) => {
        state.paymentMethodsIsLoading = false;
        state.paymentMethodsError = action.payload;
      });
  },
});

export const { actions: paymentActions } = paymentSlice;
export const { reducer: paymentReducer } = paymentSlice;
